export function getValueByCulturalEntropy(score, values) {
  let response
  switch (true) {
    case score > 0 && score <= 10:
      response = values['high']
      break
    case score > 10 && score <= 30:
      response = values['medium']
      break
    case score > 30 && score <= 100:
      response = values['low']
      break
    default:
      response = values['blank']
      break
  }
  return response
}

export function getValueByCulturalAlignment(score, values) {
  let response
  switch (true) {
    case score > 0 && score < 35:
      response = values['low']
      break
    case score >= 35 && score < 65:
      response = values['medium']
      break
    case score >= 65 && score <= 100:
      response = values['high']
      break
    default:
      response = values['blank']
      break
  }
  return response
}

export function getValueByParticipation(score, values) {
  let response
  switch (true) {
    case score < 50:
      response = values['low']
      break
    case score >= 50 && score < 75:
      response = values['medium']
      break
    case score <= 100:
      response = values['high']
      break
    default:
      response = values['blank']
      break
  }
  return response
}

export function getValueByNpscore(score, values) {
  let response
  switch (true) {
    case score >= -100 && score < -30:
      response = values['low']
      break
    case score >= -30 && score < 30:
      response = values['medium']
      break
    case score <= 100:
      response = values['high']
      break
    default:
      response = values['blank']
      break
  }
  return response
}

export function getValueByScore(score, values) {
  let response
  switch (true) {
    case score >= 0 && score < 5:
      response = values['low']
      break
    case score < 7.5:
      response = values['medium']
      break
    case score <= 10:
      response = values['high']
      break
    default:
      response = values['blank']
      break
  }
  return response
}

export function getValueByMaturityLevel(score, values) {
  let response
  switch (true) {
    case score >= 0 && score < 3:
      response = values['low']
      break
    case score < 4:
      response = values['medium']
      break
    case score <= 5:
      response = values['high']
      break
    default:
      response = values['blank']
      break
  }
  return response
}

const bind = el => {
  const { metricValue, metricType } = el.dataset

  let className

  el.classList.remove('metric-low')
  el.classList.remove('metric-medium')
  el.classList.remove('metric-high')
  el.classList.remove('metric-blank')

  const values = {
    low: 'metric-low',
    medium: 'metric-medium',
    high: 'metric-high',
    blank: 'metric-blank',
  }

  if (['enpscore', 'lnpscore'].includes(metricType)) {
    className = getValueByNpscore(parseFloat(metricValue), values)
  } else if (metricType === 'participation') {
    className = getValueByParticipation(parseFloat(metricValue), values)
  } else if (metricType === 'culturalAlignment') {
    className = getValueByCulturalAlignment(parseFloat(metricValue), values)
  } else if (metricType === 'culturalEntropy') {
    className = getValueByCulturalEntropy(parseFloat(metricValue), values)
  } else if (metricType === 'maturityLevel') {
    className = getValueByMaturityLevel(parseFloat(metricValue), values)
  } else {
    className = getValueByScore(parseFloat(metricValue), values)
  }
  el.classList.add(className)
}

export default {
  bind,
  update(el, binding) {
    binding.modifiers && binding.modifiers.update && bind(el)
  },
}
